const LENGTH_PROPERTIES = new Set([
  'height',
  'width',
  'minHeight',
  'minWidth',
  'maxHeight',
  'maxWidth',
  'top',
  'right',
  'bottom',
  'left',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'gap',
  'fontSize',
  'borderWidth',
]);

const STYLE_CLASS_MAP = {
  alignItems: {
    center: 'csp-align-items-center',
  },
  backgroundColor: {
    transparent: 'csp-bg-transparent',
    white: 'csp-bg-white',
    '#ffffff': 'csp-bg-white',
  },
  border: {
    none: 'csp-border-none',
    '1px solid rgb(241 236 236)': 'csp-border-light',
    'solid 1px #5555': 'csp-border-muted',
  },
  borderColor: {
    '#009ca6': 'csp-border-info',
    '#0057b8': 'csp-border-primary',
    '#ba0c2f': 'csp-border-error',
    '#fedb00': 'csp-border-warning',
    '#99c221': 'csp-border-success',
  },
  borderLeft: {
    0: 'csp-border-left-0',
  },
  color: {
    '#000000': 'csp-color-black',
    '#5bc2e7': 'csp-color-info-light',
    '#25cd25': 'csp-color-green',
    '#df1414': 'csp-color-danger',
    '#888': 'csp-color-muted',
    red: 'csp-color-red',
  },
  cursor: {
    pointer: 'csp-cursor-pointer',
  },
  display: {
    none: 'csp-display-none',
    flex: 'csp-display-flex',
    grid: 'csp-display-grid',
    block: 'csp-display-block',
  },
  flexDirection: {
    row: 'csp-flex-row',
    column: 'csp-flex-column',
  },
  flexGrow: {
    1: 'csp-flex-grow-1',
    2: 'csp-flex-grow-2',
  },
  flexWrap: {
    nowrap: 'csp-flex-nowrap',
  },
  fontSize: {
    '12px': 'csp-font-size-12',
    '16px': 'csp-font-size-16',
    '8rem': 'csp-font-size-8rem',
  },
  fontWeight: {
    600: 'csp-font-weight-600',
    700: 'csp-font-weight-700',
  },
  gap: {
    '20px': 'csp-gap-20',
  },
  gridTemplateRows: {
    'auto 1fr': 'csp-grid-rows-auto-1fr',
  },
  height: {
    '24px': 'csp-height-24',
    '100%': 'csp-height-full',
    '300px': 'csp-height-300',
    '350px': 'csp-height-350',
  },
  justifyContent: {
    center: 'csp-justify-center',
    'space-between': 'csp-justify-between',
  },
  lineHeight: {
    1: 'csp-line-height-1',
  },
  listStyle: {
    inside: 'csp-list-style-inside',
  },
  margin: {
    '0 auto': 'csp-margin-auto-horizontal',
  },
  marginLeft: {
    auto: 'csp-margin-left-auto',
    '12px': 'csp-margin-left-12',
  },
  marginRight: {
    0: 'csp-margin-right-0',
  },
  marginTop: {
    '5px': 'csp-margin-top-5',
    '-5px': 'csp-margin-top-neg-5',
    12: 'csp-margin-top-12',
  },
  maxHeight: {
    '700px': 'csp-max-height-700',
  },
  maxWidth: {
    '10%': 'csp-max-width-10pct',
    '66%': 'csp-max-width-66pct',
    '75%': 'csp-max-width-75pct',
    '95vw': 'csp-max-width-95vw',
    '100%': 'csp-max-width-full',
  },
  minHeight: {
    '20px': 'csp-min-height-20',
    '38px': 'csp-min-height-38',
    '350px': 'csp-min-height-350',
    '530px': 'csp-min-height-530',
    '600px': 'csp-min-height-600',
  },
  minWidth: {
    0: 'csp-min-width-0',
    '0px': 'csp-min-width-0',
    '50px': 'csp-min-width-50',
    '70px': 'csp-min-width-70',
    '80px': 'csp-min-width-80',
    '90px': 'csp-min-width-90',
    '100px': 'csp-min-width-100',
    '110px': 'csp-min-width-110',
    '120px': 'csp-min-width-120',
    '130px': 'csp-min-width-130',
    '140px': 'csp-min-width-140',
    '150px': 'csp-min-width-150',
    '200px': 'csp-min-width-200',
    '240px': 'csp-min-width-240',
    '250px': 'csp-min-width-250',
    '265px': 'csp-min-width-265',
    '300px': 'csp-min-width-300',
    '320px': 'csp-min-width-320',
    '333px': 'csp-min-width-333',
  },
  opacity: {
    0.8: 'csp-opacity-80',
    1: 'csp-opacity-100',
  },
  overflow: {
    auto: 'csp-overflow-auto',
    hidden: 'csp-overflow-hidden',
  },
  overflowX: {
    auto: 'csp-overflow-x-auto',
  },
  padding: {
    0: 'csp-padding-0',
    '2rem 4rem': 'csp-padding-2rem-4rem',
  },
  paddingRight: {
    '10px': 'csp-padding-right-10',
  },
  position: {
    inherit: 'csp-position-inherit',
    relative: 'csp-position-relative',
  },
  right: {
    '30px': 'csp-right-30',
  },
  tableLayout: {
    fixed: 'csp-table-layout-fixed',
  },
  textAlign: {
    left: 'csp-text-left',
    right: 'csp-text-right',
    center: 'csp-text-center',
    true: 'csp-text-left',
  },
  transform: {
    'rotate(45deg)': 'csp-rotate-45',
  },
  whiteSpace: {
    nowrap: 'csp-white-space-nowrap',
  },
  width: {
    '6%': 'csp-width-6pct',
    '10%': 'csp-width-10pct',
    '25px': 'csp-width-25',
    '30%': 'csp-width-30pct',
    '36px': 'csp-width-36',
    '40px': 'csp-width-40',
    '40%': 'csp-width-40pct',
    '50px': 'csp-width-50',
    '70px': 'csp-width-70',
    '80px': 'csp-width-80',
    '90px': 'csp-width-90',
    '100px': 'csp-width-100',
    '140px': 'csp-width-140',
    '200px': 'csp-width-200',
    '240px': 'csp-width-240',
    '250px': 'csp-width-250',
    '265px': 'csp-width-265',
    '320px': 'csp-width-320',
    '333px': 'csp-width-333',
    '100%': 'csp-width-full',
    '80%': 'csp-width-80pct',
    '1100px': 'csp-width-1100',
  },
  zIndex: {
    0: 'csp-z-index-0',
    1: 'csp-z-index-1',
  },
};

const normalizeStyleValue = (property, value) => {
  if (value === null || value === undefined) return value;

  if (typeof value === 'number' && LENGTH_PROPERTIES.has(property)) {
    return value === 0 ? '0px' : `${value}px`;
  }

  return String(value);
};

export const mergeClassNames = (...classNames) =>
  classNames
    .flatMap((className) => {
      if (!className) return [];
      if (Array.isArray(className)) return className;

      return String(className)
        .split(' ')
        .map((token) => token.trim())
        .filter(Boolean);
    })
    .filter((className, index, values) => values.indexOf(className) === index)
    .join(' ');

export const styleObjectToClassNames = (style) => {
  if (!style) return '';

  return Object.entries(style)
    .map(([property, rawValue]) => {
      const value = normalizeStyleValue(property, rawValue);
      return STYLE_CLASS_MAP[property]?.[value] || '';
    })
    .filter(Boolean)
    .join(' ');
};
